import { isNetworkError } from "./isNetworkError.js";
import { retry } from "./retry.js";

export function retryFailedToFetch<T>(fn: () => Promise<T>): Promise<T> {
	return retry(null, [1000, 2000, 5000], fn, (error) => ({ retry: isNetworkError(error) }));
}
